(function () {
  'use strict';

  /* =========================================================
   *  SHARED CONSTS / CONFIG
   * ========================================================= */
  var CONFIG = { readyCheck:150, maxWait:4000, delay:80, hazmatDelay:150, retry:400 };

  var hazmatProId = theme.settings.hazmatProId || '44451573727388';
  var hazmatLimitedId = theme.settings.hazmatLimitedId || '44451520512156';
  var tempSensProId = theme.settings.tempSensProId || '44451517857948';

  var HAZMAT_TITLE   = 'Hazardous Charge';

  var EXCLUDED_PRODUCTS = [
    "8261508006044","8261509939356","8261510365340",
    "8261520097436","8261520261276","8261520359580","8263960625308"
  ];

  var EXCLUDED_TITLES = [
    "Bank Charges","Pallet Charge","Miscellaneous Charge",
    "Insulated Container Charge","Handling Charges",
    "Limited/Excepted Quantity Hazardous Charge"
  ];

  /* =========================================================
   *  SHARED HELPERS / STATE
   * ========================================================= */
  function getHandleFromUrl(url){ if(!url) return null; var m=url.match(/\/products\/([^?\/]+)/); return m?m[1]:null; }

  function waitForCartReady(){
    return new Promise(function(resolve){
      var attempts=0, max=Math.floor(CONFIG.maxWait/CONFIG.readyCheck);
      (function check(){
        attempts++;
        var container = (document.querySelector('#upCart')?.shadowRoot || document).querySelector('#UpcartPopup, .upcart-cart');
        var items=document.querySelectorAll('.upcart-product-item');
        if(container && items.length>0) return resolve(true);
        if(attempts>=max) return resolve(false);
        setTimeout(check, CONFIG.readyCheck);
      })();
    });
  }

  // caches
  var productMetaCache = new Map(); // handle -> meta object
  var leadTimeCache    = new Map(); // handle -> { variants: {variantId: value}}
  var initializedMeta  = false;

  /* ---------- ONE container per row + dedupe ---------- */
  function getPropsContainer(row){
    if(!row) return null;
    var preferred=row.querySelector('.upcart-item-properties[data-chem-owned="true"]');
    if(preferred) return preferred;

    var hasOurBlock=row.querySelector('.upcart-item-properties [data-meta-block], .upcart-item-properties [data-lead-time]');
    if(hasOurBlock){
      var c1=hasOurBlock.closest('.upcart-item-properties');
      c1.setAttribute('data-chem-owned','true');
      return c1;
    }

    var existing=row.querySelector('.upcart-item-properties');
    if(existing){ existing.setAttribute('data-chem-owned','true'); return existing; }

    var hook=row.querySelector('.styles_ProductRow__productTitleAndVariant__');
    if(!hook) return null;
    var c=document.createElement('div');
    c.className='upcart-item-properties TextStyle--variationSubdued UpcartDesignSettings__cartTextSubduedColor';
    c.setAttribute('data-chem-owned','true');
    hook.appendChild(c);
    return c;
  }

  function dedupeInside(container) {
  if (!container) return;

  // 1) Keep only ONE meta block & ONE lead-time line
  var metas = container.querySelectorAll('[data-meta-block]');
  for (var i = 1; i < metas.length; i++) metas[i].remove();

  var leads = container.querySelectorAll('[data-lead-time]');
  for (var j = 1; j < leads.length; j++) leads[j].remove();

  // 2) Remove legacy/unscoped duplicates that are NOT inside our blocks
  //    (older scripts or theme may have rendered these)
  var ALLOWED_PARENTS = new Set();
  if (metas[0]) ALLOWED_PARENTS.add(metas[0]);
  if (leads[0]) ALLOWED_PARENTS.add(leads[0]);

  var DUP_KEYS_RE = /^(Catalog Number|CAS Number|Purity|Hazmat|Lead time)\s*:\s*$/i;

  container.querySelectorAll('p.upcart-item-property').forEach(function(p) {
    // if this <p> lives inside our scoped nodes -> keep
    var keep = false;
    ALLOWED_PARENTS.forEach(function(parent) {
      if (!parent) return;
      if (parent === p || parent.contains(p)) keep = true;
    });
    if (keep) return;

    // if it has data-lead-time attribute -> keep (it's our scoped one)
    if (p.hasAttribute('data-lead-time')) return;

    // if its <strong> label matches one of our keys -> it's a duplicate -> remove
    var strong = p.querySelector('strong');
    if (strong && DUP_KEYS_RE.test((strong.textContent || '').trim())) {
      p.remove();
    }
  });
}

  let cartCache = null;
  let cartPromise = null;

  function getCart(force = false) {
    if (!force && cartCache) return Promise.resolve(cartCache);
    if (!force && cartPromise) return cartPromise;

    cartPromise = fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        cartCache = cart;
        cartPromise = null;
        return cart;
      })
      .catch(err => {
        cartPromise = null;
        throw err;
      });

    return cartPromise;
  }

  /* ---------- Shared /cart/change queue ---------- */
  var changeQueue=[], changing=false;
  var inFlightAdds = new Set();
  function enqueueChange(status = 'change', payload){
    cartCache = null;
    cartPromise = null;
    changeQueue.push({ status, payload });
    if(!changing) drain();
  }

  function drain(){
    var job = changeQueue.shift();
    if(!job) return;

    changing = true;

    const url = job.status === 'add'
      ? '/cart/add.js'
      : '/cart/change.js';

    fetch(url, {
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body: JSON.stringify(job.payload)
    })
    .then(res => {
      if (!res.ok) return res.json().then(err => { throw new Error(err.description || err.message || 'API Error'); });
      return res.json();
    })
    .then(function(cart) {
      if (cart && typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
      }
    })
    .catch(function(err){ console.error('[UpCart] Cart update failed:', err.message); })
    .finally(function(){
      if (job.status === 'add') inFlightAdds.delete(String(job.payload.id));
      setTimeout(function(){ changing=false; drain(); }, CONFIG.delay || 140);
    });
  }

  /* =========================================================
   *  MODULE A: PRODUCT META INJECTION + HAZMAT CHARGE
   *  (also pushes Catalog/CAS/Purity/Hazmat to checkout)
   * ========================================================= */
  var MetaHazmat=(function(){
    var metaData={};               // handle or product_id -> meta
    let checkingUpchargeItems = false;

    function decodeHTML(str) {
      const txt = document.createElement('textarea');
      txt.innerHTML = str;
      return txt.value;
    }

    function fetchProductMeta(handle) {
      if (!handle) return Promise.resolve({});

      const cached = productMetaCache.get(handle);
      if (cached) return Promise.resolve(cached);

      return fetch(`/products/${handle}?view=meta-json`)
        .then(res => {
          if (!res.ok) throw new Error('Network error');
          return res.json();
        })
        .then(data => {
          const meta = {};

          if (data.catalog) meta['Catalog Number'] = data.catalog;
          if (data.cas) meta['CAS Number'] = data.cas;
          if (data.purity) meta['Purity'] = decodeHTML(data.purity);

          if (data.hazmat) {
            meta['Hazmat'] = 'Yes';
          }

          if (data.temperature_sensitive) {
            meta['Temperature Sensitive'] = 'Yes';
          }

          productMetaCache.set(handle, meta);
          return meta;
        })
        .catch(() => {
          const empty = {};
          productMetaCache.set(handle, empty);
          return empty;
        });
    }

    function preloadMeta(){
      return getCart().then(function(cart) {
        var items=(cart&&cart.items)||[], batchSize=3, batches=[];
        for(var i=0;i<items.length;i+=batchSize) batches.push(items.slice(i,i+batchSize));
        if(!batches.length) return;
        var first=batches[0];
        return Promise.all(first.map(function(it){
          if(!metaData[it.handle]){
            return fetchProductMeta(it.handle).then(function(m){ metaData[it.handle]=m; metaData[it.product_id]=m; });
          }
          return Promise.resolve();
        })).then(function(){
          if(batches.length>1){
            setTimeout(function(){
              for(var b=1;b<batches.length;b++){
                batches[b].forEach(function(it){
                  if(!metaData[it.handle]){
                    fetchProductMeta(it.handle).then(function(m){ metaData[it.handle]=m; metaData[it.product_id]=m; });
                  }
                });
              }
            },80);
          }
        });
      }).catch(function(err){ console.warn('Preload error:',err); });
    }

    // Stable meta renderer
    function injectMeta(item, meta) {
      if (!item || !meta) return;

      const container = getPropsContainer(item);
      if (!container) return;

      dedupeInside(container)

      let block = container.querySelector('[data-meta-block]');
      if (!block) {
        block = document.createElement('div');
        block.setAttribute('data-meta-block', 'true');
        container.prepend(block);
      }

      const entries = Object.entries(meta).filter(([key, value]) => {
        return (
          !key.startsWith('__') &&
          value &&
          String(value).trim() !== ''
        );
      });

      // Nothing to render → cleanup
      if (!entries.length) {
        block.innerHTML = '';
        return;
      }

      // Build DOM safely (no innerHTML injection)
      const frag = document.createDocumentFragment();

      for (const [key, value] of entries) {
        const p = document.createElement('p');
        p.className = 'upcart-item-property';

        const strong = document.createElement('strong');
        strong.textContent = `${key}: `;

        const span = document.createElement('span');
        span.textContent = value;

        p.appendChild(strong);
        p.appendChild(span);
        frag.appendChild(p);
      }

      // Replace content (no duplication)
      block.innerHTML = '';
      block.appendChild(frag);
    }

    // Push meta to checkout (line-item properties)
    let syncInFlight = false;

    function syncMetaProperties() {
      if (syncInFlight) return Promise.resolve();
      syncInFlight = true;

      return getCart().then(function(cart) {
        var items = (cart && cart.items) || [];
        if (!items.length) return;

        var need = new Set();

        items.forEach(function(ci){
          if(String(ci.variant_id)===String(hazmatProId)) return;
          if(EXCLUDED_PRODUCTS.includes(String(ci.product_id))) return;
          if(EXCLUDED_TITLES.includes(ci.title)) return;

          var h = ci.handle || getHandleFromUrl(ci.url || ci.product_url || '');
          if (h && !productMetaCache.has(h)) need.add(h);
        });

        return Promise.all(Array.from(need).map(fetchProductMeta)).then(function(){

          var updates = [];

          items.forEach(function(ci){
            if(String(ci.variant_id)===String(hazmatProId)) return;
            if(EXCLUDED_PRODUCTS.includes(String(ci.product_id))) return;
            if(EXCLUDED_TITLES.includes(ci.title)) return;

            var h = ci.handle || getHandleFromUrl(ci.url || ci.product_url || '');
            if (!h) return;

            var meta = productMetaCache.get(h) || {};

            var propsWant = {};
            if(meta['Catalog Number']) propsWant['Catalog Number'] = meta['Catalog Number'];
            if(meta['CAS Number']) propsWant['CAS Number'] = meta['CAS Number'];
            if(meta['Purity']) propsWant['Purity'] = meta['Purity'];
            if(meta['Hazmat'] === 'Yes') propsWant['Hazmat'] = 'Yes';
            if(meta['Temperature Sensitive'] === 'Yes') propsWant['Temperature Sensitive'] = 'Yes';

            if (!Object.keys(propsWant).length) return;

            var existing = ci.properties || {};
            var merged = Object.assign({}, existing);

            let changed = false;

            Object.keys(propsWant).forEach(function(k){
              if ((existing[k] || '') !== propsWant[k]) {
                merged[k] = propsWant[k];
                changed = true;
              }
            });

            if (changed) {
              updates.push({
                id: ci.key,
                quantity: ci.quantity,
                properties: merged
              });
            }
          });

          // 🔥 Queue individual updates for each item
          if (updates.length) {
            updates.forEach(payload => {
              enqueueChange('change', payload);
            });
          }
        });

      }).finally(function(){
        syncInFlight = false;
      }).catch(function(){});
    }

    function processItems(){
      var rows = (document.querySelector('#upCart')?.shadowRoot || document).querySelectorAll('.upcart-product-item');
      if (!rows.length) return Promise.resolve();

      var jobs = [];

      for (var i = 0; i < rows.length; i++){
        (function(row){
          var a = row.querySelector('.upcart-product-title-link'); 
          if (!a) return;

          var title = (a.textContent || '').trim(); 
          if (title === HAZMAT_TITLE) return;

          var handle = getHandleFromUrl(a.href); 
          if (!handle) return;

          const container = getPropsContainer(row);
          if (container) dedupeInside(container);

          jobs.push(
            (productMetaCache.get(handle)
              ? Promise.resolve(productMetaCache.get(handle))
              : fetchProductMeta(handle)
            ).then(function(m){
              injectMeta(row, m || {});
            })
          );
        })(rows[i]);
      }

      return Promise.all(jobs).then(function(){
        syncMetaProperties();
      });
    }

    function checkUpchargeItems(){
      if (checkingUpchargeItems) return;

      // Defer if there are pending sync changes in the queue
      if (changeQueue.length > 0 || changing) {
        setTimeout(checkUpchargeItems, CONFIG.retry || 400);
        return;
      }

      checkingUpchargeItems = true;

      const shadow = document.querySelector('#upCart')?.shadowRoot;
      const upcartPopup = shadow?.querySelector('#UpcartPopup');
      const rows = upcartPopup ? upcartPopup.querySelectorAll('.upcart-product-item') : [];
      const hazmatLimitedItem = hazmatLimitedId ? Array.from(rows).find(node => node.id.includes(hazmatLimitedId)) : null;
      
      return getCart(true).then(cart => {
        const { items } = cart;

        const hasHazmatPro = items.some(item => item.variant_id === Number(hazmatProId));
        const hasHazmatLimited = items.some(item => item.variant_id === Number(hazmatLimitedId));
        const hasTempSensPro = items.some(item => item.variant_id === Number(tempSensProId));

        const __hazmat = items.filter((item) => {
          const { properties } = item;
          return properties["__hazmat"];
        });

        const __hazmat_pro = __hazmat.filter((item) => {
          const { properties } = item;
          return properties["__hazmat"] === 'pro';
        });

        const __temperature_sensitive = items.filter((item) => {
          const { properties } = item;
          return properties["__temperature_sensitive"];
        });

        // Remove all Hazmat items
        if((__hazmat.length === 0) && (__hazmat_pro.length === 0)) {
          if(hasHazmatPro) {
            removeItemFromCart(cart, hazmatProId);
          }
          if(hasHazmatLimited) {
            removeItemFromCart(cart, hazmatLimitedId);
          }
        }

        // Replace Hazmat item
        if((__hazmat_pro.length > 0)) {
          if(hasHazmatPro && hasHazmatLimited && hazmatLimitedItem) {
            hazmatLimitedItem.classList.add("hidden");
          }
          if(hasHazmatLimited) {
            removeItemFromCart(cart, hazmatLimitedId);
          }
          if(!hasHazmatPro) {
            addItemToCart(hazmatProId);
          }
        }

        if((__hazmat_pro.length === 0) && (__hazmat.length > 0)) {
          if(hasHazmatPro) {
            removeItemFromCart(cart, hazmatProId);
          }
          if(!hasHazmatLimited) {
            addItemToCart(hazmatLimitedId);
          }
        }

        // Progess temperature_sensitive
        if((__temperature_sensitive.length > 0)) {
          if(!hasTempSensPro) {
            addItemToCart(tempSensProId);
          }
        }

        if(hasTempSensPro && (__temperature_sensitive.length === 0)) {
          removeItemFromCart(cart, tempSensProId);
        }

      })
      .catch(function(e){ console.warn('Fetch cart error:',e); })
      .finally(() => {
        setTimeout(() => { checkingUpchargeItems = false; }, 150);
      });
    }

    function removeItemFromCart(cart, variantId) {
      const line = cart.items.find(i => i.variant_id === Number(variantId));
      if (!line) return;
      enqueueChange('change', { id: line.key, quantity: 0 });
    }

    function addItemToCart(variantId, quantity = 1) {
      const vid = String(variantId);
      // Prevent duplicate adds: skip if this variant is in-flight or still queued
      if (inFlightAdds.has(vid)) return;
      if (changeQueue.some(j => j.status === 'add' && String(j.payload.id) === vid)) return;
      inFlightAdds.add(vid);
      enqueueChange('add', { id: variantId, quantity });
    }

    function init(){
      if(initializedMeta) return processItems();
      return Promise.all([waitForCartReady(), preloadMeta()]).then(processItems).then(function(){ initializedMeta=true; });
    }

    function observeRowRerenders(){
      let timer;
      let locked = false;

      function trigger(){
        if (locked) return;
        locked = true;

        processItems();

        setTimeout(() => {
          locked = false;
        }, 200); // hard throttle window
      }

      function debounce(){
        clearTimeout(timer);
        timer = setTimeout(trigger, 80);
      }

      const container = document.querySelector('#CartPopup, .upcart-cart') || document.body;

      const mo = new MutationObserver(function(muts){
        let reinject = false;

        for (let m of muts){
          for (let n of m.addedNodes){
            if (
              n.nodeType === 1 &&
              (
                n.matches?.('.upcart-product-item') ||
                n.querySelector?.('.upcart-product-item')
              )
            ) {
              reinject = true;
              break;
            }
          }
          if (reinject) break;
        }

        if (reinject) debounce();
      });

      mo.observe(container,{ childList:true, subtree:true });
    }

    return {
      init:init,
      process:processItems,
      checkUpchargeItems:checkUpchargeItems,
      observeRowRerenders:observeRowRerenders,
      debug:function(){ console.log('Meta cache:',productMetaCache.size); },
      reset:function(){ initializedMeta=false; productMetaCache.clear(); metaData={}; init(); },
      syncMetaProperties:syncMetaProperties
    };
  })();

  /* =========================================================
   *  MODULE B: HEADER CART COUNT SYNC
   * ========================================================= */
  var CartCount=(function(){
    var selectors={ header:'#header__cart-count-number', bubble:'#cart-icon-bubble .header__cart-count-number', label:'.header__cart-label .header__cart-count-number' };
    var bubbleSel='#cart-icon-bubble', currentCount=0, queue=[], processing=false;

    function getCount(){ return getCart().then(function(cart) { return cart.item_count||0; }).catch(function(){ return 0; }); }

    function render(count){
      if(count===currentCount) return;
      var bubble=document.querySelector(bubbleSel), str=String(count);
      Object.keys(selectors).forEach(function(k){ document.querySelectorAll(selectors[k]).forEach(function(el){ el.textContent=str; }); });
      if(bubble){
        if(count>0){ bubble.style.display=''; bubble.style.opacity='1'; }
        else { bubble.style.opacity='0'; setTimeout(function(){ if(bubble.style.opacity==='0') bubble.style.display='none'; },150); }
        bubble.querySelectorAll('.visually-hidden').forEach(function(s){ s.textContent=count+(count===1?' item':' items'); });
      }
      currentCount=count;
    }

    function flush(){ if(processing||!queue.length) return; processing=true; var n=queue[queue.length-1]; queue=[]; render(n);
      setTimeout(function(){ processing=false; if(queue.length) flush(); },50); }

    function push(n){ queue.push(n); flush(); }
    function refresh(){ getCount().then(push); }

    function hookFormsAndAjax() {
      const CART_REGEX = /\/cart\/(add|change|update|clear)/;
      const FORM_ADD_SELECTOR = 'form[action*="/cart/add"], .js-product-form';
      const FORM_CART_SELECTOR = 'form[action*="/cart"]';

      // spam refresh
      let refreshTimeout;
      const triggerRefresh = (delay = 150) => {
        clearTimeout(refreshTimeout);
        refreshTimeout = setTimeout(refresh, delay);
      };

      /* ------------------------------
      * Form submit listeners
      * ------------------------------ */
      const bindForm = (selector, delay) => {
        document.querySelectorAll(selector).forEach(form => {
          if (form.__upcartBound) return;
          form.__upcartBound = true;

          form.addEventListener('submit', () => {
            triggerRefresh(delay);
          });
        });
      };

      bindForm(FORM_ADD_SELECTOR, 300);
      bindForm(FORM_CART_SELECTOR, 200);

      /* ------------------------------
      * FETCH patch (only once)
      * ------------------------------ */
      if (window.fetch && !window.__upcartFetchPatched) {
        window.__upcartFetchPatched = true;

        const originalFetch = window.fetch;
        window.fetch = function (...args) {
          const firstArg = args[0];
          const url = (firstArg instanceof Request) ? firstArg.url : String(firstArg);
          const promise = originalFetch.apply(this, args);

          if (typeof url === 'string' && CART_REGEX.test(url)) {
            promise
              .then(() => triggerRefresh())
              .catch(() => triggerRefresh());
          }

          return promise;
        };
      }

      /* ------------------------------
      * XHR patch (only once)
      * ------------------------------ */
      if (window.XMLHttpRequest && !window.__upcartXHRPatched) {
        window.__upcartXHRPatched = true;

        const open = XMLHttpRequest.prototype.open;
        const send = XMLHttpRequest.prototype.send;

        XMLHttpRequest.prototype.open = function (method, url) {
          this.__url = url;
          return open.apply(this, arguments);
        };

        XMLHttpRequest.prototype.send = function () {
          if (this.__url && CART_REGEX.test(this.__url)) {
            this.addEventListener('load', () => {
              if (this.status >= 200 && this.status < 300) {
                triggerRefresh();
              }
            });

            this.addEventListener('error', () => triggerRefresh());
          }

          return send.apply(this, arguments);
        };
      }

      /* ------------------------------
      * Mutation Observer
      * ------------------------------ */
      const observer = new MutationObserver(mutations => {
        for (const m of mutations) {
          for (const node of m.addedNodes) {
            if (node.nodeType !== 1) continue;

            if (
              node.matches?.('.cart-items, .upcart-product-item') ||
              node.querySelector?.(FORM_ADD_SELECTOR)
            ) {
              triggerRefresh(100);
              return;
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }

    function init(){
      return getCart().then(function(cart){
        currentCount = cart.item_count || 0;

        render(currentCount);
        hookFormsAndAjax();

        document.addEventListener('cart:refresh', function(){
          getCart(true).then(function(cart){
            const newCount = cart.item_count || 0;

            if(newCount !== currentCount){
              push(newCount);
            }
          });
        });

        window.addEventListener('aftersell-upcart:public-events:cart-updated', function(){
          getCart(true).then(function(cart){
            const newCount = cart.item_count || 0;

            if(newCount !== currentCount){
              push(newCount);
            }
          });
        });
      });
    }

    return { init:init, refresh:refresh, update:function(n){ (typeof n==='number')?push(n):refresh(); } };
  })();

  /* =========================================================
   *  MODULE C: LEAD TIME UI + PUSH TO CHECKOUT
   * ========================================================= */
  var LeadTime=(function(){
    var PUSH_TO_CHECKOUT=true;

    function fetchLeadTimeMap(handle){
      if(!handle) return Promise.resolve(null);
      if(leadTimeCache.has(handle)) return Promise.resolve(leadTimeCache.get(handle));
      return fetch('/products/'+handle+'?view=leadtime-json',{credentials:'same-origin'})
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(json){ leadTimeCache.set(handle,json); return json; })
        .catch(function(){ return null; });
    }

    function leadTimeLabel(val){
      if(val===-1) return 'In stock';
      if(val===0)  return 'Out of stock — no lead time';
      if(typeof val==='number' && val>0) return 'Back in '+val+' day'+(val>1?'s':'');
      return '';
    }

    function injectLeadTimeUI(row,msg){
      if(!row) return;

      const container = getPropsContainer(row);
      if (!container) return;

      dedupeInside(container)

      var line=container.querySelector('[data-lead-time]');
      if(!line){
        line=document.createElement('p');
        line.setAttribute('data-lead-time','true');
        var strong=document.createElement('strong'); strong.textContent='Lead time: ';
        var span=document.createElement('span'); span.setAttribute('data-lead-time-value','true'); span.textContent=msg||'—';
        line.appendChild(strong); line.appendChild(span); container.appendChild(line);
      } else {
        var val=line.querySelector('[data-lead-time-value]');
        if(!val){ val=document.createElement('span'); val.setAttribute('data-lead-time-value','true'); line.appendChild(val); }
        val.textContent=msg||'—';
      }
    }

    function ensureLeadTimeProperty(ci,msg){
      if(!PUSH_TO_CHECKOUT||!msg) return;
      var existing=ci.properties||{}, merged=Object.assign({},existing);
      if(existing['Lead time']===msg) return;
      merged['Lead time']=msg;
      enqueueChange('change', { id:ci.key, quantity:ci.quantity, properties:merged });
    }

    function sync(){
      return getCart().then(function(cart) {
        var items=(cart&&cart.items)||[]; if(!items.length) return;

        var handles=new Set();
        items.forEach(function(ci){
          if(String(ci.variant_id)===String(hazmatProId)) return;
          if(EXCLUDED_PRODUCTS.includes(String(ci.product_id))) return;
          if(EXCLUDED_TITLES.includes(ci.title)) return;
          var h=ci.handle||getHandleFromUrl(ci.url||ci.product_url||''); if(h) handles.add(h);
        });

        return Promise.all(Array.from(handles).map(fetchLeadTimeMap)).then(function(){
          document.querySelectorAll('.upcart-product-item').forEach(function(row){
            var a=row.querySelector('.upcart-product-title-link'); if(!a) return;
            var title=(a.textContent||'').trim(); if(title===HAZMAT_TITLE) return;

            var rowVarId=null; if(row.id && row.id.indexOf(':')>-1) rowVarId=row.id.split(':')[0];

            var handle=getHandleFromUrl(a.href), map=leadTimeCache.get(handle), raw=null;
            if(map && map.variants){ if(rowVarId && map.variants[rowVarId]!==undefined) raw=map.variants[rowVarId]; }

            var msg=leadTimeLabel(raw);
            injectLeadTimeUI(row,msg);

            if(msg){
              var cartLine=(cart.items||[]).find(function(ci){ return String(ci.variant_id)===String(rowVarId); });
              if(cartLine) ensureLeadTimeProperty(cartLine,msg);
            }
          });
        });
      }).catch(function(){});
    }

    function init(){ sync(); }
    return { init:init, sync:sync };
  })();

  /* =========================================================
   *  EVENT WIRING (CENTRALIZED)
   * ========================================================= */
  function wireEvents() {
    let scheduled = false;
    let hazmatScheduled = false;

    function scheduleAll() {
      if (scheduled) return;
      scheduled = true;

      setTimeout(() => {
        scheduled = false;

        MetaHazmat.process();
        LeadTime.sync();
        CartCount.refresh();

      }, 50);
    }

    function scheduleHazmat() {
      if (hazmatScheduled) return;
      hazmatScheduled = true;

      setTimeout(() => {
        hazmatScheduled = false;
        MetaHazmat.checkUpchargeItems();
      }, CONFIG.hazmatDelay);
    }

    /* ------------------------------
    * Unified handler
    * ------------------------------ */
    function handleCartChange({ hazmat = false, countOnly = false } = {}) {
      if (hazmat) scheduleHazmat();

      if (countOnly) {
        CartCount.refresh();
        return;
      }

      scheduleAll();
    }

    /* ------------------------------
    * Inject Custom HTML
    * ------------------------------ */
    function injectCustomHTML() {
      const host = document.querySelector('#upCart');
      if (!host || !host.shadowRoot) return;

      const shadow = host.shadowRoot;

      const popup = shadow.querySelector('#UpcartPopup');
      if (!popup) return;

      // prevent duplicate
      if (shadow.querySelector('[data-custom-block]')) return;

      const container = document.createElement('div');
      container.setAttribute('data-custom-block', 'true');

      container.innerHTML = `
        <div style="margin-left: -64px; transform: translateX(-48px);">
          <a href="/cart" style="color: #333; font-size: 14px;">View cart</a>
        </div>
      `;

      // 👇 Choose where to inject
      const target = popup.querySelector('.upcart-header');
      if (target) target.appendChild(container);
    }

    /* ------------------------------
    * UpCart events
    * ------------------------------ */
    window.addEventListener('aftersell-upcart:public-events:cart-loaded', () => {
      injectCustomHTML();
      MetaHazmat.syncMetaProperties();
      handleCartChange({ hazmat: true });
    });

    window.addEventListener('aftersell-upcart:public-events:item-added', () => {
      handleCartChange({ hazmat: true });
    });

    window.addEventListener('aftersell-upcart:public-events:item-removed', () => {
      handleCartChange({ hazmat: true });
    });

    window.addEventListener('aftersell-upcart:public-events:cart-updated', () => {
      handleCartChange();

      // cleanup dedupe here (merged)
      document.querySelectorAll('.upcart-product-item').forEach(row => {
        const c = getPropsContainer(row);
        dedupeInside(c);
      });
    });

    window.addEventListener('aftersell-upcart:public-events:quantity-updated', () => {
      handleCartChange();
    });

    /* ------------------------------
    * Theme/custom fallbacks
    * ------------------------------ */
    window.addEventListener('on:cart:add', () => {
      handleCartChange({ hazmat: true });
    });

    window.addEventListener('on:line-item:change', () => {
      handleCartChange();
    });

    window.addEventListener('on:cart:error', () => {
      handleCartChange({ countOnly: true });
    });

    function refreshUpCart() {
      if (typeof window.upcartRefreshCart !== 'function') return;
      getCart(true).then(function() {
        window.upcartRefreshCart();
      });
    }

    document.addEventListener('cart:update', () => { handleCartChange(); refreshUpCart(); });
    document.addEventListener('cart:refresh', () => { handleCartChange(); refreshUpCart(); });
    document.addEventListener('cart:change', () => { handleCartChange(); refreshUpCart(); });

    /* ------------------------------
    * Observers
    * ------------------------------ */
    MetaHazmat.observeRowRerenders();

    /* ------------------------------
    * Clear queue on cart close to prevent UpCart overlay getting stuck
    * ------------------------------ */
    if (typeof window.upcartSubscribeCartClosed === 'function') {
      window.upcartSubscribeCartClosed(function() {
        MetaHazmat.syncMetaProperties();
      });
    }

    /* ------------------------------
    * On /cart page: bidirectional sync between cart page and UpCart drawer
    * ------------------------------ */
    if (window.location.pathname.startsWith('/cart')) {
      function closeUpcartDrawer() {
        if (typeof window.upcartCloseCart === 'function') window.upcartCloseCart();
      }
      closeUpcartDrawer();
      setTimeout(closeUpcartDrawer, 500);

      // Flag to prevent the loop: cart page change → UpCart refresh → UpCart event → cart page refresh
      var upCartSilentRefreshTimer = null;
      var upCartSilentRefreshing = false;

      // Direction 1: Cart page → UpCart drawer (silent, no open)
      var silentRefreshInFlight = false;
      function silentUpCartRefresh() {
        if (typeof window.upcartRefreshCart !== 'function') return;
        // Prevent a second in-flight refresh from spawning a concurrent checkUpchargeItems run
        if (silentRefreshInFlight) return;
        silentRefreshInFlight = true;
        upCartSilentRefreshing = true;
        clearTimeout(upCartSilentRefreshTimer);
        getCart(true).then(function() {
          silentRefreshInFlight = false;
          window.upcartRefreshCart();
          // Wait until checkUpchargeItems drain is idle, then refresh cart page with final state
          awaitDrainAndRefreshCart(0);
        }).catch(function() {
          silentRefreshInFlight = false;
          upCartSilentRefreshing = false;
        });
      }

      // Poll until the change queue drains, then clear the silent-refresh lock and
      // re-render the cart page so fee swaps (e.g. HazmatPro → HazmatLimited) are visible.
      function awaitDrainAndRefreshCart(attempt) {
        clearTimeout(upCartSilentRefreshTimer);
        if (attempt > 10) { upCartSilentRefreshing = false; return; }
        upCartSilentRefreshTimer = setTimeout(function() {
          if (changeQueue.length > 0 || changing) {
            awaitDrainAndRefreshCart(attempt + 1);
            return;
          }
          upCartSilentRefreshing = false;
          var cartItems = document.querySelector('cart-items');
          if (cartItems && typeof cartItems.refresh === 'function') {
            cartItems.refresh();
          }
        }, 300);
      }

      // Direction 2: UpCart drawer → Cart page (re-render sections without reload)
      function refreshCartPageFromUpCart() {
        if (upCartSilentRefreshing) return;
        var cartItems = document.querySelector('cart-items');
        if (cartItems && typeof cartItems.refresh === 'function') {
          cartItems.refresh();
        }
      }

      // Cart page updates (quantity change / remove) → silently sync UpCart data
      document.addEventListener('on:line-item:change', silentUpCartRefresh);

      // UpCart drawer user actions → sync back to cart page
      // cart-updated covers quantity changes; item-added/item-removed cover add/remove
      ['aftersell-upcart:public-events:cart-updated',
       'aftersell-upcart:public-events:item-added',
       'aftersell-upcart:public-events:item-removed',
       'aftersell-upcart:public-events:quantity-updated'].forEach(function(evt) {
        window.addEventListener(evt, refreshCartPageFromUpCart);
      });
    }

    /* ------------------------------
    * Initial boot
    * ------------------------------ */
    MetaHazmat.init();
    LeadTime.init();
    CartCount.init();
  }

  /* =========================================================
   *  PUBLIC DEBUG / MANUAL HOOKS
   * ========================================================= */
  window.upcartDebug=function(){ console.log('[DEBUG] productMetaCache:', productMetaCache.size); };
  window.upcartRefresh=function(){ MetaHazmat.process(); LeadTime.sync(); CartCount.refresh(); MetaHazmat.syncMetaProperties(); };
  window.upcartReset=function(){ productMetaCache.clear(); leadTimeCache.clear(); initializedMeta=false; MetaHazmat.reset(); LeadTime.sync(); CartCount.refresh(); };
  window.refreshCartCount=function(){ CartCount.refresh(); };
  window.updateCartCount=function(n){ CartCount.update(n); };

  /* =========================================================
   *  BOOT
   * ========================================================= */
  function start(){
    function quickInit(){ wireEvents(); }
    if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', function(){ setTimeout(quickInit,80); }); }
    else { setTimeout(quickInit,80); }
  }
  start();
})();
